import React, { useState, useEffect } from 'react';
import { Div, RowDiv, Section, Text } from 'styles';
import { Button, Icon, Img, InfoDiv, Input, LineText, Modal, Radio, SubTitle, Switch } from 'components';
import { useImmer } from 'use-immer';
import { Spinner } from 'components/loading/Spinner';
import { findIndex } from 'lodash';
import ModalActuatorFanDetail from 'components/dialogs/house-control/modal-actuator-fan-detail';
import ModalActuatorAcDetail from 'components/dialogs/house-control/modal-actuator-ac-detail';
import ModalActuatorWindowDetail from 'components/dialogs/house-control/modal-actuator-window-detail';

import houseActuatorService from 'services/house/house-actuator-service';

import * as S from './HouseControlStyle';

export function HouseControl(props) {
  
  const [actuatorData, updateActuatorData] = useImmer({
    apiCallIndex: 0,
    actuators: [
      { id: 'fan_1', label: 'Fan_1', type: 'Fan', sensorValue: null, loading: true},
      { id: 'fan_2', label: 'Fan_2', type: 'Fan', sensorValue: null, loading: true},
      { id: 'fan_3', label: 'Fan_3', type: 'Fan', sensorValue: null, loading: true},
      { id: 'fan_4', label: 'Fan_4', type: 'Fan', sensorValue: null, loading: true},
      { id: 'airconditioner_1', label: 'Airconditioner_1', type: 'Aircon', sensorValue: null, loading: true},
      { id: 'airconditioner_2', label: 'Airconditioner_2', type: 'Aircon', sensorValue: null, loading: true},
      { id: 'double_side_window_1', label: 'Side_Window_1', type: 'Window', sensorValue: null, loading: true},
      { id: 'double_side_window_2', label: 'Side_Window_2', type: 'Window', sensorValue: null, loading: true},
    ]
  });

  const [detailModalData, updateDetailModalData] = useImmer({
    type: null,
    open: false,
    id: null,
    sensorValue: null,
    title: '',
    airconData: null
  })

  const getActuatorData = async (id) => {
    const actuatorIndex = findIndex(actuatorData.actuators, (a) => a.id === id)

    if (actuatorIndex < 0) {
      return
    }

    let data = null;

    // updateActuatorData((draft) => {
    //   draft.actuators[actuatorIndex].sensorValue = null;
    //   draft.actuators[actuatorIndex].loading = true;
    // })

    try {
      if (id === 'fan_1'){
        data = await houseActuatorService.getHouseActuatorFanDetail(id);
      }else if (id === 'fan_2'){
        data = await houseActuatorService.getHouseActuatorFanDetail(id);
      }else if (id === 'fan_3'){
        data = await houseActuatorService.getHouseActuatorFanDetail(id);
      }else if (id === 'fan_4'){
        data = await houseActuatorService.getHouseActuatorFanDetail(id);
      }else{
        data = await houseActuatorService.getHouseActuatorDetail(id);
      }
      
      // const sensorType = data[0].sensor_type;
      // const sensorValue = data[0].sensor_value;

      // if(sensorType === 'FAN_1'){
        
      //   updateActuatorData((draft) => {
      //     const fanIndex = findIndex(draft.actuators, (a) => a.id === 'fan_3');
      //     if (fanIndex >= 0) {
      //       draft.actuators[fanIndex].sensorValue = sensorValue; // 새로운 상태 설정
      //       draft.actuators[fanIndex].loading = false;          // 로딩 완료 설정
      //     }
      //   });
      // }else if(sensorType === 'FAN_2'){
        
      //   updateActuatorData((draft) => {
      //     const fanIndex = findIndex(draft.actuators, (a) => a.id === 'fan_1');
      //     if (fanIndex >= 0) {
      //       draft.actuators[fanIndex].sensorValue = sensorValue; // 새로운 상태 설정
      //       draft.actuators[fanIndex].loading = false;          // 로딩 완료 설정
      //     }
      //   });
      // }else if(sensorType === 'FAN_3'){
        
      //   updateActuatorData((draft) => {
      //     const fanIndex = findIndex(draft.actuators, (a) => a.id === 'fan_4');
      //     if (fanIndex >= 0) {
      //       draft.actuators[fanIndex].sensorValue = sensorValue; // 새로운 상태 설정
      //       draft.actuators[fanIndex].loading = false;          // 로딩 완료 설정
      //     }
      //   });

      // }else if(sensorType === 'FAN_4'){
        
      //   updateActuatorData((draft) => {
      //     const fanIndex = findIndex(draft.actuators, (a) => a.id === 'fan_2');
      //     if (fanIndex >= 0) {
      //       draft.actuators[fanIndex].sensorValue = sensorValue; // 새로운 상태 설정
      //       draft.actuators[fanIndex].loading = false;          // 로딩 완료 설정
      //     }
      //   });
      // }
      
    } catch (e) {
      console.error(e);
    }

    if (data !== null) {
      updateActuatorData((draft) => {
        draft.actuators[actuatorIndex].sensorValue = data.length > 0 ? data[0].sensor_value : null;
        draft.actuators[actuatorIndex].loading = false;
      })
    }
  }

  useEffect(() => {
    actuatorData.actuators.forEach((actuator) => {
      getActuatorData(actuator.id);
    })
  }, [actuatorData.apiCallIndex])


  return (
    <>
      <Section>
        <SubTitle title="제어 시스템" sub="Actuator" desc="전체 제어 상태" />
        <InfoDiv>장비 아이콘을 클릭하여 상세 제어 요소를 설정할 수 있습니다.</InfoDiv>
        <S.ControlList>
          {
            actuatorData.actuators.map((actuator) => (
              <li key={actuator.id}>
                <S.HoverDiv
                  onClick={async () => {  // 'async' 키워드를 추가하여 비동기 함수로 선언
                    let airconData = null;
                    try {
                      // 에어컨 데이터 가져오기 (acId로 actuator.id 사용)
                      if(actuator.id === 'airconditioner_1' || actuator.id === 'airconditioner_2'){
                        airconData = await houseActuatorService.getAirconditionData(actuator.id);
                      }else if(actuator.id === 'fan_1'||actuator.id === 'fan_2'||actuator.id === 'fan_3'||actuator.id === 'fan_4'){
                        airconData = await houseActuatorService.getFanData(actuator.id);
                      }else{
                        airconData = await houseActuatorService.getWindowData(actuator.id);
                      }
                      
                    } catch (e) {
                      console.error('에어컨 데이터 가져오기 실패:', e);
                    }
                    
                    // 상태 업데이트 (모달 열기)
                    updateDetailModalData((draft) => {
                      draft.id = actuator.id;
                      draft.type = actuator.type;
                      draft.open = true;
                      draft.title = actuator.label;
                      draft.airconData = airconData;
                    });
                  }}
                >
                  <Icon name={actuator.type} />
                  <S.ConDiv>
                    <Text $type="m18">{actuator.label}</Text>
                    { actuator.loading ?
                      <Spinner $width={20} $height={20}/>
                      :
                      <>
                        {/* { actuator.type !== 'Window' &&
                          <Button $size="control" $type="control">
                            {actuator.sensorValue > 0 ? 'ON' : 'OFF'}
                          </Button>
                        } */}
                        { actuator.type === 'Fan' &&
                          <Button $size="control" $type="control">
                            {actuator.sensorValue > 0 ? 'ON' : 'OFF'}
                          </Button>
                        }
                        { actuator.type === 'Aircon' &&
                          <Button $size="control" $type="control">
                            {actuator.sensorValue > 0 ? 'ON' : 'OFF'}
                          </Button>
                        }
                        { actuator.type === 'Window' &&
                        <>
                          <Button $size="control" $type="control">
                            {/* {actuator.sensorValue === 1 ? '열림' : '닫힘'} */}
                            {actuator.sensorValue === 0
                            ? '닫힘'
                            : actuator.sensorValue === 1
                            ? '열림'
                            : actuator.sensorValue === 2
                            ? '자동'
                            : '알 수 없음'}
                          </Button>
                          </>
                        }
                      </>
                    }
                  </S.ConDiv>
                </S.HoverDiv>
              </li>
            ))
          }
        </S.ControlList>
        <LineText $margin="32px 0 12px">센서위치 확인</LineText>
        <Div $minHeight={552}>
          <Img src="houseControl" $objectFit="cover" $width="100%" />
        </Div>
      </Section>

      { detailModalData.open && detailModalData.type === 'Fan' &&
        <ModalActuatorFanDetail id={detailModalData.id} sensorValue={detailModalData.sensorValue} title={detailModalData.title} open={detailModalData.open} setOpen={(open) => {
          updateDetailModalData((draft) => {
            draft.open = open;
          })
        }} afterCancel={() => {

        }} afterSubmit={() => {
          getActuatorData(detailModalData.id);
        }}/>
      }

      { detailModalData.open && detailModalData.type === 'Aircon' &&
        <ModalActuatorAcDetail id={detailModalData.id} sensorValue={detailModalData.sensorValue} title={detailModalData.title} open={detailModalData.open} airconData={detailModalData.airconData} setOpen={(open) => {
          updateDetailModalData((draft) => {
            draft.open = open;
          })
        }} afterCancel={() => {

        }} afterSubmit={() => {
          getActuatorData(detailModalData.id);
        }}/>
      }

      { detailModalData.open && detailModalData.type === 'Window' &&
        <ModalActuatorWindowDetail id={detailModalData.id} sensorValue={detailModalData.sensorValue} title={detailModalData.title} open={detailModalData.open} setOpen={(open) => {
          updateDetailModalData((draft) => {
            draft.open = open;
          })
        }} afterCancel={() => {

        }} afterSubmit={() => {
          getActuatorData(detailModalData.id);
        }}/>
      }
    </>
  );
}
